var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"px-3"},[_c('input',{attrs:{"type":"range","min":_vm.low,"max":_vm.high,"disabled":""},domProps:{"value":_vm.price}})])])}
var staticRenderFns = []

export { render, staticRenderFns }